// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Liberate Global parent brand + Enable LXP product theme */

:root {
  --liberate-red: var(--brand-red);
  --liberate-red-dark: var(--brand-red-dark);
  --liberate-red-light: var(--brand-red-light);
  --liberate-red-soft: var(--brand-red-soft);
  --liberate-red-bg: #fdf3f3;
  --liberate-red-bg-deep: #fae8e8;
  --liberate-charcoal: #1a1a1a;
  --liberate-gray-900: #2d2d2d;
  --liberate-gray-700: #404040;
  --liberate-gray-600: #525252;
  --liberate-gray-400: #9ca3af;
  --liberate-gray-100: #f5f5f5;
  --liberate-gray-50: #fafafa;
  --liberate-border: #e8d4d4;
  --liberate-white: #ffffff;
}

.landing-page {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: var(--liberate-charcoal);
  background: var(--liberate-red-bg);
}

/* ── Brand lockup: Liberate logo + Enable LXP ── */
.landing-brand-link {
  display: inline-block;
  transition: opacity 0.2s ease;
}

.landing-brand-link:hover {
  opacity: 0.92;
  text-decoration: none;
}

.landing-brand-lockup {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.landing-brand-parent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
}

.landing-brand-logo-img {
  display: block;
}

.landing-brand-parent-label {
  font-size: 0.625rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: 600;
  line-height: 1.2;
}

.landing-brand-divider {
  width: 2px;
  height: 36px;
  background: var(--liberate-red);
  opacity: 0.35;
  flex-shrink: 0;
  border-radius: 2px;
}

.landing-brand-divider-dark {
  background: rgba(255, 255, 255, 0.2);
}

.landing-brand-product-name {
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: var(--liberate-red-dark);
}

.landing-brand-product-tag {
  font-size: 0.6875rem;
  letter-spacing: 0.02em;
  line-height: 1.3;
  margin-top: 0.1rem;
  color: var(--liberate-gray-700);
}

/* ── Hero — warm Liberate red tint ── */
.landing-hero {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(ellipse 80% 60% at 90% 10%, rgba(165, 29, 36, 0.18), transparent 55%),
    radial-gradient(ellipse 55% 45% at 5% 90%, rgba(165, 29, 36, 0.12), transparent 50%),
    linear-gradient(135deg, #fff5f5 0%, #fde8e8 45%, #ffffff 100%);
  color: var(--liberate-charcoal);
  border-bottom: 3px solid var(--liberate-red);
}

.landing-hero-accent {
  position: absolute;
  width: 480px;
  height: 480px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(165, 29, 36, 0.14) 0%, transparent 68%);
  top: -100px;
  right: -100px;
  pointer-events: none;
}

.landing-hero-accent-left {
  position: absolute;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(165, 29, 36, 0.1) 0%, transparent 70%);
  bottom: -60px;
  left: -40px;
  pointer-events: none;
}

.landing-hero-line {
  display: inline-block;
  width: 48px;
  height: 3px;
  background: var(--liberate-red);
  border-radius: 2px;
  margin-bottom: 1.25rem;
}

.landing-hero-eyebrow {
  display: inline-block;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--liberate-red);
  margin-bottom: 1rem;
  padding: 0.35rem 0.9rem;
  background: rgba(165, 29, 36, 0.1);
  border: 1px solid rgba(165, 29, 36, 0.2);
  border-radius: 9999px;
}

.landing-hero-title {
  font-size: clamp(2rem, 5vw, 3.25rem);
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.03em;
  color: var(--liberate-charcoal);
  margin-bottom: 1.25rem;
}

.landing-hero-title em {
  font-style: normal;
  color: var(--liberate-red);
}

.landing-hero-subtitle {
  font-size: 1.125rem;
  line-height: 1.75;
  color: var(--liberate-gray-700);
  max-width: 540px;
  font-weight: 450;
}

.landing-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 0.9375rem;
  background-color: var(--liberate-red) !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: 0 4px 14px rgba(165, 29, 36, 0.3);
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.landing-btn-primary:hover,
.landing-btn-primary:focus,
.landing-btn-primary:active {
  background-color: var(--liberate-red-dark) !important;
  color: #ffffff !important;
  border: none !important;
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(165, 29, 36, 0.35);
}

.landing-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 0.9375rem;
  background: #ffffff;
  color: var(--liberate-red);
  border: 1.5px solid var(--liberate-red);
  transition: background 0.2s ease, color 0.2s ease;
}

.landing-btn-secondary:hover {
  background: var(--liberate-red);
  color: #ffffff;
}

.landing-btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 0.9375rem;
  background: transparent;
  color: var(--liberate-red);
  border: 1.5px solid var(--liberate-red);
  transition: background 0.2s ease, color 0.2s ease;
}

.landing-btn-outline:hover {
  background: var(--liberate-red);
  color: #ffffff;
}

.landing-stat-block {
  text-align: center;
}

.landing-stat-value {
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  line-height: 1;
  color: var(--liberate-red);
  letter-spacing: -0.02em;
}

.landing-stat-label {
  font-size: 0.8125rem;
  color: var(--liberate-gray-700);
  margin-top: 0.35rem;
  line-height: 1.4;
  font-weight: 500;
}

.landing-section-eyebrow {
  display: inline-block;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--liberate-red);
  margin-bottom: 0.75rem;
  padding: 0.3rem 0.85rem;
  background: var(--liberate-red-soft);
  border-radius: 9999px;
}

.landing-section-title {
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--liberate-charcoal);
  line-height: 1.2;
}

.landing-section-title::after {
  content: '';
  display: block;
  width: 56px;
  height: 3px;
  background: var(--liberate-red);
  border-radius: 2px;
  margin: 0.85rem auto 0;
}

.landing-section-header-left .landing-section-title::after {
  margin-left: 0;
  margin-right: auto;
}

.landing-section-desc {
  color: var(--liberate-gray-700);
  font-size: 1.0625rem;
  line-height: 1.7;
  max-width: 640px;
}

.landing-section-white {
  background: #ffffff;
}

.landing-section-red {
  background: var(--liberate-red-bg);
}

.landing-section-red-deep {
  background: var(--liberate-red-bg-deep);
}

.landing-feature-card {
  background: var(--liberate-white);
  border: 1px solid var(--liberate-border);
  border-left: 4px solid var(--liberate-red);
  border-radius: 1rem;
  padding: 2rem;
  height: 100%;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.landing-feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(165, 29, 36, 0.1);
  border-color: rgba(165, 29, 36, 0.35);
  border-left-color: var(--liberate-red-dark);
}

.landing-feature-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--liberate-red);
  color: #ffffff;
  font-size: 1.35rem;
  margin-bottom: 1.25rem;
}

.landing-trust-strip {
  background: linear-gradient(135deg, var(--liberate-red-dark) 0%, var(--liberate-red) 50%, var(--liberate-red-light) 100%);
  color: #ffffff;
  padding: 2.75rem 0;
}

.landing-trust-strip .landing-stat-value {
  color: #ffffff;
}

.landing-trust-strip .landing-stat-label {
  color: rgba(255, 255, 255, 0.88);
}

.landing-nav-bar {
  background: rgba(255, 255, 255, 0.98) !important;
  border-bottom: 2px solid var(--liberate-red);
  box-shadow: 0 2px 16px rgba(165, 29, 36, 0.08);
}

.landing-nav-link {
  font-weight: 500;
  font-size: 0.9375rem;
  padding: 0.5rem 0.75rem !important;
  border-radius: 0.375rem;
  color: var(--liberate-gray-900) !important;
  transition: color 0.2s ease, background 0.2s ease;
}

.landing-nav-link:hover {
  color: var(--liberate-red) !important;
  background: var(--liberate-red-soft);
}

.landing-nav-cta {
  padding: 0.5rem 1.25rem !important;
  border-radius: 9999px !important;
  font-weight: 600 !important;
  background: var(--liberate-red) !important;
  color: #fff !important;
  margin-left: 0.5rem;
}

.landing-nav-cta:hover {
  background: var(--liberate-red-dark) !important;
  color: #fff !important;
}

.landing-nav-parent {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--liberate-gray-600) !important;
  padding: 0.5rem 0.75rem !important;
}

.landing-nav-parent:hover {
  color: var(--liberate-red) !important;
}

.landing-testimonial-card {
  background: var(--liberate-white);
  border: 1px solid var(--liberate-border);
  border-top: 3px solid var(--liberate-red);
  border-radius: 1rem;
  padding: 2rem;
  height: 100%;
  position: relative;
}

.landing-testimonial-card::before {
  content: '"';
  position: absolute;
  top: 0.75rem;
  left: 1.25rem;
  font-size: 3.5rem;
  line-height: 1;
  color: rgba(165, 29, 36, 0.12);
  font-family: Georgia, serif;
}

.landing-faq .accordion-item {
  border: 1px solid var(--liberate-border) !important;
  border-radius: 0.75rem !important;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.landing-faq .accordion-button {
  font-weight: 600;
  color: var(--liberate-charcoal);
  background: var(--liberate-white);
  box-shadow: none !important;
}

.landing-faq .accordion-button:not(.collapsed) {
  background: var(--liberate-red-soft);
  color: var(--liberate-red);
}

.landing-brand-on-dark .landing-brand-parent {
  background: #ffffff;
  padding: 0.35rem 0.65rem;
  border-radius: 0.5rem;
}

.landing-brand-on-dark .landing-brand-parent-label {
  color: rgba(255, 255, 255, 0.55) !important;
}

.landing-cta-band {
  background: linear-gradient(135deg, var(--liberate-red-dark) 0%, #6b1218 100%);
  color: #ffffff;
}

.landing-cta-band .landing-btn-secondary {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.45);
  background: transparent;
}

.landing-cta-band .landing-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.7);
}

.landing-cta-band .landing-section-title {
  color: #ffffff;
}

.landing-cta-band .landing-btn-primary {
  background-color: #ffffff !important;
  color: var(--liberate-red) !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.landing-cta-band .landing-btn-primary:hover,
.landing-cta-band .landing-btn-primary:focus,
.landing-cta-band .landing-btn-primary:active {
  background-color: #f5f5f5 !important;
  color: var(--liberate-red-dark) !important;
}


.landing-footer {
  background: linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 100%);
  color: #b0b0b0;
  border-top: 4px solid var(--liberate-red);
}

.landing-footer-brand {
  color: #ffffff;
}

.landing-footer-link {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
}

.landing-footer-link:hover {
  color: #ffffff;
}

.landing-mock-dashboard {
  border-radius: 1rem;
  overflow: hidden;
  background: var(--liberate-white);
  border: 2px solid rgba(165, 29, 36, 0.2);
  box-shadow: 0 24px 48px rgba(165, 29, 36, 0.12);
}

.landing-mock-bar {
  height: 40px;
  background: linear-gradient(90deg, var(--liberate-red-dark), var(--liberate-red));
  border-bottom: none;
  display: flex;
  align-items: center;
  padding: 0 14px;
  gap: 6px;
}

.landing-mock-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.landing-use-case-card {
  border-radius: 1rem;
  padding: 1.5rem;
  background: var(--liberate-white);
  border: 1px solid var(--liberate-border);
  border-bottom: 3px solid var(--liberate-red);
  height: 100%;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.landing-use-case-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(165, 29, 36, 0.12);
  border-color: rgba(165, 29, 36, 0.3);
}

.landing-about-band {
  background: linear-gradient(180deg, var(--liberate-red-bg-deep) 0%, var(--liberate-red-bg) 100%);
  border-top: 1px solid rgba(165, 29, 36, 0.15);
  border-bottom: 1px solid rgba(165, 29, 36, 0.15);
}

.landing-about-band .landing-stat-value {
  font-size: 2.5rem;
}

.landing-link-arrow {
  color: var(--liberate-red);
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  transition: gap 0.2s ease;
}

.landing-link-arrow:hover {
  color: var(--liberate-red-dark);
  gap: 0.55rem;
}

/* ── EduGenie showcase ── */
.landing-edugenie {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(ellipse 70% 55% at 95% 20%, rgba(165, 29, 36, 0.16), transparent 55%),
    radial-gradient(ellipse 50% 40% at 0% 80%, rgba(165, 29, 36, 0.1), transparent 50%),
    linear-gradient(135deg, #1a1a1a 0%, #2a1214 48%, #1a1a1a 100%);
  color: #f5f5f5;
  border-top: 3px solid var(--liberate-red);
  border-bottom: 3px solid var(--liberate-red);
}

.landing-edugenie .landing-section-eyebrow {
  color: #fca5a5;
  background: rgba(179, 32, 37, 0.25);
  border-color: rgba(252, 165, 165, 0.35);
}

.landing-edugenie .landing-section-title {
  color: #ffffff;
}

.landing-edugenie .landing-section-title::after {
  background: var(--liberate-red);
}

.landing-edugenie .landing-section-desc {
  color: rgba(245, 245, 245, 0.82);
  max-width: 34rem;
}

.landing-edugenie-name {
  font-style: normal;
  color: #fca5a5;
}

.landing-edugenie-caps {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem 1rem;
}

@media (max-width: 575.98px) {
  .landing-edugenie-caps {
    grid-template-columns: 1fr;
  }
}

.landing-edugenie-cap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.9);
}

.landing-edugenie-cap-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(179, 32, 37, 0.45);
  color: #fecaca;
  flex-shrink: 0;
}

.landing-edugenie-note {
  font-size: 0.8125rem;
  color: rgba(245, 245, 245, 0.55);
}

.landing-edugenie-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 1.5rem 1.25rem 1.75rem;
}

.landing-edugenie-panel-glow {
  position: absolute;
  inset: 10% 15%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(179, 32, 37, 0.45) 0%, transparent 70%);
  pointer-events: none;
  filter: blur(8px);
}

.landing-edugenie-avatar-wrap {
  position: relative;
  z-index: 1;
  width: min(240px, 55vw);
  height: min(240px, 55vw);
  border-radius: 50%;
  padding: 6px;
  background: linear-gradient(145deg, #B32025, #6b1218 55%, #fca5a5);
  box-shadow: 0 20px 48px rgba(179, 32, 37, 0.35);
  animation: landing-edugenie-float 5s ease-in-out infinite;
}

.landing-edugenie-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  background: #1a1a1a;
  display: block;
}

.landing-edugenie-chat-preview {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 380px;
  padding: 1.15rem 1.25rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(252, 165, 165, 0.25);
  backdrop-filter: blur(8px);
}

.landing-edugenie-chat-head {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.75rem;
}

.landing-edugenie-badge {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #fff;
  background: var(--liberate-red);
  padding: 0.2rem 0.55rem;
  border-radius: 9999px;
}

.landing-edugenie-chat-title {
  font-weight: 700;
  color: #fff;
  font-size: 0.95rem;
}

.landing-edugenie-chat-intro {
  font-size: 0.8125rem;
  color: rgba(245, 245, 245, 0.65);
}

.landing-edugenie-prompt {
  font-size: 0.875rem;
  color: #fecaca;
  padding: 0.55rem 0.75rem;
  margin-bottom: 0.45rem;
  border-radius: 0.65rem;
  background: rgba(179, 32, 37, 0.22);
  border: 1px solid rgba(252, 165, 165, 0.18);
}

.landing-edugenie-prompt:last-child {
  margin-bottom: 0;
}

@keyframes landing-edugenie-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .landing-edugenie-avatar-wrap {
    animation: none;
  }
}

/* ── Powerful marketing sections (KREDO / LearnWorlds-inspired) ── */
.landing-hero-proof {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  align-items: center;
  margin-top: 1.5rem;
  font-size: 0.8125rem;
  color: var(--liberate-gray-600);
  font-weight: 500;
}

.landing-hero-proof-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--liberate-red);
  display: inline-block;
}

.landing-hero-visual {
  position: relative;
}

.landing-hero-float-chip {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 0.85rem;
  background: #fff;
  border: 1px solid var(--liberate-border);
  border-radius: 9999px;
  box-shadow: 0 10px 28px rgba(165, 29, 36, 0.14);
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--liberate-charcoal);
  animation: landing-edugenie-float 4.5s ease-in-out infinite;
}

.landing-hero-float-chip img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.landing-hero-float-chip--top {
  top: -8px;
  right: 8px;
}

.landing-hero-float-chip--bottom {
  bottom: 18px;
  left: -6px;
  animation-delay: 0.8s;
}

.landing-mock-progress {
  height: 6px;
  border-radius: 9999px;
  background: #f0e4e4;
  overflow: hidden;
  margin-top: 0.35rem;
}

.landing-mock-progress > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--liberate-red), #e05a5e);
}

.landing-mock-course-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid #f0e8e8;
}

.landing-mock-course-row:last-child {
  border-bottom: none;
}

.landing-mock-course-icon {
  width: 36px;
  height: 36px;
  border-radius: 0.55rem;
  background: var(--liberate-red-bg-deep);
  color: var(--liberate-red);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.9rem;
}

.landing-audience-card {
  height: 100%;
  padding: 1.75rem;
  border-radius: 1.15rem;
  background: #fff;
  border: 1px solid var(--liberate-border);
  border-top: 4px solid var(--liberate-red);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.landing-audience-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(165, 29, 36, 0.12);
}

.landing-audience-card ul {
  margin: 1rem 0 0;
  padding: 0;
  list-style: none;
}

.landing-audience-card li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--liberate-gray-700);
  margin-bottom: 0.45rem;
}

.landing-pillar-card {
  height: 100%;
  padding: 1.65rem;
  border-radius: 1.15rem;
  background: #fff;
  border: 1px solid var(--liberate-border);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
  position: relative;
  overflow: hidden;
}

.landing-pillar-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--liberate-red), #e05a5e);
  opacity: 0;
  transition: opacity 0.22s ease;
}

.landing-pillar-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 36px rgba(165, 29, 36, 0.12);
  border-color: rgba(165, 29, 36, 0.28);
}

.landing-pillar-card:hover::before {
  opacity: 1;
}

.landing-pillar-num {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #fca5a5;
  margin-bottom: 0.75rem;
}

.landing-solution-card {
  height: 100%;
  padding: 1.5rem;
  border-radius: 1rem;
  background: linear-gradient(180deg, #fff 0%, var(--liberate-red-bg) 100%);
  border: 1px solid var(--liberate-border);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.landing-solution-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 32px rgba(165, 29, 36, 0.1);
}

.landing-solution-card .landing-link-arrow {
  margin-top: 1rem;
}

.landing-steps {
  display: grid;
  gap: 1.25rem;
}

@media (min-width: 992px) {
  .landing-steps {
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
  }
}

.landing-step {
  position: relative;
  padding: 1.5rem 1.25rem;
  border-radius: 1rem;
  background: #fff;
  border: 1px solid var(--liberate-border);
  height: 100%;
}

.landing-step-num {
  font-size: 2rem;
  font-weight: 800;
  line-height: 1;
  color: var(--liberate-red);
  opacity: 0.35;
  margin-bottom: 0.75rem;
  letter-spacing: -0.04em;
}

.landing-enterprise-band {
  background:
    radial-gradient(ellipse 60% 50% at 0% 50%, rgba(165, 29, 36, 0.12), transparent 55%),
    linear-gradient(135deg, #fff 0%, var(--liberate-red-bg) 100%);
  border-top: 1px solid rgba(165, 29, 36, 0.12);
  border-bottom: 1px solid rgba(165, 29, 36, 0.12);
}

.landing-enterprise-item {
  display: flex;
  gap: 1rem;
  padding: 1.15rem 0;
  border-bottom: 1px solid rgba(165, 29, 36, 0.12);
}

.landing-enterprise-item:last-child {
  border-bottom: none;
}

.landing-enterprise-icon {
  width: 44px;
  height: 44px;
  border-radius: 0.75rem;
  background: var(--liberate-red);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.1rem;
}

.landing-nav-link-hash {
  cursor: pointer;
}

html {
  scroll-behavior: smooth;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  .landing-hero-float-chip {
    animation: none;
  }
}

/* ── Compact enquiry contact panel ── */
.landing-contact-panel {
  border-radius: 1.15rem;
  overflow: hidden;
  border: 1px solid var(--liberate-border);
  background: #fff;
  box-shadow: 0 12px 32px rgba(165, 29, 36, 0.08);
  position: sticky;
  top: 96px;
}

.landing-contact-panel-head {
  background: linear-gradient(135deg, var(--liberate-red-dark), var(--liberate-red));
  color: #fff;
  padding: 1.35rem 1.35rem 1.15rem;
}

.landing-contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

@media (max-width: 575.98px) {
  .landing-contact-grid {
    grid-template-columns: 1fr;
  }

  .landing-contact-panel {
    position: static;
  }
}

.landing-contact-item {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.15rem;
  border-bottom: 1px solid var(--liberate-border);
  border-right: 1px solid var(--liberate-border);
  min-height: 0;
}

.landing-contact-item:nth-child(2n) {
  border-right: none;
}

.landing-contact-item:nth-last-child(-n + 2) {
  border-bottom: none;
}

@media (max-width: 575.98px) {
  .landing-contact-item {
    border-right: none;
  }

  .landing-contact-item:last-child {
    border-bottom: none;
  }

  .landing-contact-item:nth-last-child(-n + 2) {
    border-bottom: 1px solid var(--liberate-border);
  }
}

.landing-contact-item-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--liberate-red-bg-deep);
  color: var(--liberate-red);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.landing-contact-item-title {
  font-size: 0.8125rem;
  font-weight: 700;
  margin: 0 0 0.25rem;
  color: var(--liberate-charcoal);
}

.landing-contact-item-line {
  font-size: 0.8125rem;
  color: var(--liberate-gray-700);
  line-height: 1.45;
}

.landing-contact-item-link {
  display: block;
  color: var(--liberate-red);
  text-decoration: none;
  font-weight: 600;
}

.landing-contact-item-link:hover {
  text-decoration: underline;
  color: var(--liberate-red-dark);
}

.landing-contact-footnote {
  padding: 0.85rem 1.15rem 1.15rem;
  font-size: 0.75rem;
  color: var(--liberate-gray-600);
  border-top: 1px solid var(--liberate-border);
  background: var(--liberate-red-bg);
}

.landing-contact-footnote a {
  color: var(--liberate-red);
  font-weight: 600;
  text-decoration: none;
}

.landing-contact-footnote a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/landing-theme.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,4CAA4C;EAC5C,0CAA0C;EAC1C,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,uFAAuF;EACvF,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;kEAGgE;EAChE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gFAAgF;EAChF,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,+EAA+E;EAC/E,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;EAChD,yBAAyB;EACzB,uBAAuB;EACvB,6CAA6C;EAC7C,iFAAiF;AACnF;;AAEA;;;EAGE,qDAAqD;EACrD,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yHAAyH;EACzH,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,2BAA2B;EAC3B,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8EAA8E;EAC9E,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;;;EAGE,oCAAoC;EACpC,0CAA0C;AAC5C;;;AAGA;EACE,6DAA6D;EAC7D,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,iFAAiF;EACjF,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,wCAAwC;EACxC,4CAA4C;EAC5C,YAAY;EACZ,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,gGAAgG;EAChG,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;kEAGgE;EAChE,cAAc;EACd,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gFAAgF;EAChF,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,kEAAkE;EAClE,+CAA+C;EAC/C,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;EACrB,+CAA+C;EAC/C,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,gFAAgF;EAChF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gEAAgE;EAChE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yEAAyE;EACzE,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;IACrC,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;;iEAE+D;EAC/D,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;AACR;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,+CAA+C;EAC/C,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Liberate Global parent brand + Enable LXP product theme */\n\n:root {\n  --liberate-red: var(--brand-red);\n  --liberate-red-dark: var(--brand-red-dark);\n  --liberate-red-light: var(--brand-red-light);\n  --liberate-red-soft: var(--brand-red-soft);\n  --liberate-red-bg: #fdf3f3;\n  --liberate-red-bg-deep: #fae8e8;\n  --liberate-charcoal: #1a1a1a;\n  --liberate-gray-900: #2d2d2d;\n  --liberate-gray-700: #404040;\n  --liberate-gray-600: #525252;\n  --liberate-gray-400: #9ca3af;\n  --liberate-gray-100: #f5f5f5;\n  --liberate-gray-50: #fafafa;\n  --liberate-border: #e8d4d4;\n  --liberate-white: #ffffff;\n}\n\n.landing-page {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--liberate-charcoal);\n  background: var(--liberate-red-bg);\n}\n\n/* ── Brand lockup: Liberate logo + Enable LXP ── */\n.landing-brand-link {\n  display: inline-block;\n  transition: opacity 0.2s ease;\n}\n\n.landing-brand-link:hover {\n  opacity: 0.92;\n  text-decoration: none;\n}\n\n.landing-brand-lockup {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.landing-brand-parent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.15rem;\n}\n\n.landing-brand-logo-img {\n  display: block;\n}\n\n.landing-brand-parent-label {\n  font-size: 0.625rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.landing-brand-divider {\n  width: 2px;\n  height: 36px;\n  background: var(--liberate-red);\n  opacity: 0.35;\n  flex-shrink: 0;\n  border-radius: 2px;\n}\n\n.landing-brand-divider-dark {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.landing-brand-product-name {\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  color: var(--liberate-red-dark);\n}\n\n.landing-brand-product-tag {\n  font-size: 0.6875rem;\n  letter-spacing: 0.02em;\n  line-height: 1.3;\n  margin-top: 0.1rem;\n  color: var(--liberate-gray-700);\n}\n\n/* ── Hero — warm Liberate red tint ── */\n.landing-hero {\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(ellipse 80% 60% at 90% 10%, rgba(165, 29, 36, 0.18), transparent 55%),\n    radial-gradient(ellipse 55% 45% at 5% 90%, rgba(165, 29, 36, 0.12), transparent 50%),\n    linear-gradient(135deg, #fff5f5 0%, #fde8e8 45%, #ffffff 100%);\n  color: var(--liberate-charcoal);\n  border-bottom: 3px solid var(--liberate-red);\n}\n\n.landing-hero-accent {\n  position: absolute;\n  width: 480px;\n  height: 480px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(165, 29, 36, 0.14) 0%, transparent 68%);\n  top: -100px;\n  right: -100px;\n  pointer-events: none;\n}\n\n.landing-hero-accent-left {\n  position: absolute;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(165, 29, 36, 0.1) 0%, transparent 70%);\n  bottom: -60px;\n  left: -40px;\n  pointer-events: none;\n}\n\n.landing-hero-line {\n  display: inline-block;\n  width: 48px;\n  height: 3px;\n  background: var(--liberate-red);\n  border-radius: 2px;\n  margin-bottom: 1.25rem;\n}\n\n.landing-hero-eyebrow {\n  display: inline-block;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--liberate-red);\n  margin-bottom: 1rem;\n  padding: 0.35rem 0.9rem;\n  background: rgba(165, 29, 36, 0.1);\n  border: 1px solid rgba(165, 29, 36, 0.2);\n  border-radius: 9999px;\n}\n\n.landing-hero-title {\n  font-size: clamp(2rem, 5vw, 3.25rem);\n  font-weight: 700;\n  line-height: 1.12;\n  letter-spacing: -0.03em;\n  color: var(--liberate-charcoal);\n  margin-bottom: 1.25rem;\n}\n\n.landing-hero-title em {\n  font-style: normal;\n  color: var(--liberate-red);\n}\n\n.landing-hero-subtitle {\n  font-size: 1.125rem;\n  line-height: 1.75;\n  color: var(--liberate-gray-700);\n  max-width: 540px;\n  font-weight: 450;\n}\n\n.landing-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.75rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 0.9375rem;\n  background-color: var(--liberate-red) !important;\n  color: #ffffff !important;\n  border: none !important;\n  box-shadow: 0 4px 14px rgba(165, 29, 36, 0.3);\n  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.landing-btn-primary:hover,\n.landing-btn-primary:focus,\n.landing-btn-primary:active {\n  background-color: var(--liberate-red-dark) !important;\n  color: #ffffff !important;\n  border: none !important;\n  transform: translateY(-1px);\n  box-shadow: 0 8px 24px rgba(165, 29, 36, 0.35);\n}\n\n.landing-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.75rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 0.9375rem;\n  background: #ffffff;\n  color: var(--liberate-red);\n  border: 1.5px solid var(--liberate-red);\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.landing-btn-secondary:hover {\n  background: var(--liberate-red);\n  color: #ffffff;\n}\n\n.landing-btn-outline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 0.9375rem;\n  background: transparent;\n  color: var(--liberate-red);\n  border: 1.5px solid var(--liberate-red);\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.landing-btn-outline:hover {\n  background: var(--liberate-red);\n  color: #ffffff;\n}\n\n.landing-stat-block {\n  text-align: center;\n}\n\n.landing-stat-value {\n  font-size: clamp(1.75rem, 4vw, 2.5rem);\n  font-weight: 800;\n  line-height: 1;\n  color: var(--liberate-red);\n  letter-spacing: -0.02em;\n}\n\n.landing-stat-label {\n  font-size: 0.8125rem;\n  color: var(--liberate-gray-700);\n  margin-top: 0.35rem;\n  line-height: 1.4;\n  font-weight: 500;\n}\n\n.landing-section-eyebrow {\n  display: inline-block;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--liberate-red);\n  margin-bottom: 0.75rem;\n  padding: 0.3rem 0.85rem;\n  background: var(--liberate-red-soft);\n  border-radius: 9999px;\n}\n\n.landing-section-title {\n  font-size: clamp(1.75rem, 3.5vw, 2.5rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--liberate-charcoal);\n  line-height: 1.2;\n}\n\n.landing-section-title::after {\n  content: '';\n  display: block;\n  width: 56px;\n  height: 3px;\n  background: var(--liberate-red);\n  border-radius: 2px;\n  margin: 0.85rem auto 0;\n}\n\n.landing-section-header-left .landing-section-title::after {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.landing-section-desc {\n  color: var(--liberate-gray-700);\n  font-size: 1.0625rem;\n  line-height: 1.7;\n  max-width: 640px;\n}\n\n.landing-section-white {\n  background: #ffffff;\n}\n\n.landing-section-red {\n  background: var(--liberate-red-bg);\n}\n\n.landing-section-red-deep {\n  background: var(--liberate-red-bg-deep);\n}\n\n.landing-feature-card {\n  background: var(--liberate-white);\n  border: 1px solid var(--liberate-border);\n  border-left: 4px solid var(--liberate-red);\n  border-radius: 1rem;\n  padding: 2rem;\n  height: 100%;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n}\n\n.landing-feature-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 40px rgba(165, 29, 36, 0.1);\n  border-color: rgba(165, 29, 36, 0.35);\n  border-left-color: var(--liberate-red-dark);\n}\n\n.landing-feature-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--liberate-red);\n  color: #ffffff;\n  font-size: 1.35rem;\n  margin-bottom: 1.25rem;\n}\n\n.landing-trust-strip {\n  background: linear-gradient(135deg, var(--liberate-red-dark) 0%, var(--liberate-red) 50%, var(--liberate-red-light) 100%);\n  color: #ffffff;\n  padding: 2.75rem 0;\n}\n\n.landing-trust-strip .landing-stat-value {\n  color: #ffffff;\n}\n\n.landing-trust-strip .landing-stat-label {\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.landing-nav-bar {\n  background: rgba(255, 255, 255, 0.98) !important;\n  border-bottom: 2px solid var(--liberate-red);\n  box-shadow: 0 2px 16px rgba(165, 29, 36, 0.08);\n}\n\n.landing-nav-link {\n  font-weight: 500;\n  font-size: 0.9375rem;\n  padding: 0.5rem 0.75rem !important;\n  border-radius: 0.375rem;\n  color: var(--liberate-gray-900) !important;\n  transition: color 0.2s ease, background 0.2s ease;\n}\n\n.landing-nav-link:hover {\n  color: var(--liberate-red) !important;\n  background: var(--liberate-red-soft);\n}\n\n.landing-nav-cta {\n  padding: 0.5rem 1.25rem !important;\n  border-radius: 9999px !important;\n  font-weight: 600 !important;\n  background: var(--liberate-red) !important;\n  color: #fff !important;\n  margin-left: 0.5rem;\n}\n\n.landing-nav-cta:hover {\n  background: var(--liberate-red-dark) !important;\n  color: #fff !important;\n}\n\n.landing-nav-parent {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: var(--liberate-gray-600) !important;\n  padding: 0.5rem 0.75rem !important;\n}\n\n.landing-nav-parent:hover {\n  color: var(--liberate-red) !important;\n}\n\n.landing-testimonial-card {\n  background: var(--liberate-white);\n  border: 1px solid var(--liberate-border);\n  border-top: 3px solid var(--liberate-red);\n  border-radius: 1rem;\n  padding: 2rem;\n  height: 100%;\n  position: relative;\n}\n\n.landing-testimonial-card::before {\n  content: '\"';\n  position: absolute;\n  top: 0.75rem;\n  left: 1.25rem;\n  font-size: 3.5rem;\n  line-height: 1;\n  color: rgba(165, 29, 36, 0.12);\n  font-family: Georgia, serif;\n}\n\n.landing-faq .accordion-item {\n  border: 1px solid var(--liberate-border) !important;\n  border-radius: 0.75rem !important;\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.landing-faq .accordion-button {\n  font-weight: 600;\n  color: var(--liberate-charcoal);\n  background: var(--liberate-white);\n  box-shadow: none !important;\n}\n\n.landing-faq .accordion-button:not(.collapsed) {\n  background: var(--liberate-red-soft);\n  color: var(--liberate-red);\n}\n\n.landing-brand-on-dark .landing-brand-parent {\n  background: #ffffff;\n  padding: 0.35rem 0.65rem;\n  border-radius: 0.5rem;\n}\n\n.landing-brand-on-dark .landing-brand-parent-label {\n  color: rgba(255, 255, 255, 0.55) !important;\n}\n\n.landing-cta-band {\n  background: linear-gradient(135deg, var(--liberate-red-dark) 0%, #6b1218 100%);\n  color: #ffffff;\n}\n\n.landing-cta-band .landing-btn-secondary {\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.45);\n  background: transparent;\n}\n\n.landing-cta-band .landing-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.7);\n}\n\n.landing-cta-band .landing-section-title {\n  color: #ffffff;\n}\n\n.landing-cta-band .landing-btn-primary {\n  background-color: #ffffff !important;\n  color: var(--liberate-red) !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.landing-cta-band .landing-btn-primary:hover,\n.landing-cta-band .landing-btn-primary:focus,\n.landing-cta-band .landing-btn-primary:active {\n  background-color: #f5f5f5 !important;\n  color: var(--liberate-red-dark) !important;\n}\n\n\n.landing-footer {\n  background: linear-gradient(180deg, #1a1a1a 0%, #0d0d0d 100%);\n  color: #b0b0b0;\n  border-top: 4px solid var(--liberate-red);\n}\n\n.landing-footer-brand {\n  color: #ffffff;\n}\n\n.landing-footer-link {\n  color: #9ca3af;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.landing-footer-link:hover {\n  color: #ffffff;\n}\n\n.landing-mock-dashboard {\n  border-radius: 1rem;\n  overflow: hidden;\n  background: var(--liberate-white);\n  border: 2px solid rgba(165, 29, 36, 0.2);\n  box-shadow: 0 24px 48px rgba(165, 29, 36, 0.12);\n}\n\n.landing-mock-bar {\n  height: 40px;\n  background: linear-gradient(90deg, var(--liberate-red-dark), var(--liberate-red));\n  border-bottom: none;\n  display: flex;\n  align-items: center;\n  padding: 0 14px;\n  gap: 6px;\n}\n\n.landing-mock-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.landing-use-case-card {\n  border-radius: 1rem;\n  padding: 1.5rem;\n  background: var(--liberate-white);\n  border: 1px solid var(--liberate-border);\n  border-bottom: 3px solid var(--liberate-red);\n  height: 100%;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.landing-use-case-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 32px rgba(165, 29, 36, 0.12);\n  border-color: rgba(165, 29, 36, 0.3);\n}\n\n.landing-about-band {\n  background: linear-gradient(180deg, var(--liberate-red-bg-deep) 0%, var(--liberate-red-bg) 100%);\n  border-top: 1px solid rgba(165, 29, 36, 0.15);\n  border-bottom: 1px solid rgba(165, 29, 36, 0.15);\n}\n\n.landing-about-band .landing-stat-value {\n  font-size: 2.5rem;\n}\n\n.landing-link-arrow {\n  color: var(--liberate-red);\n  font-weight: 600;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  transition: gap 0.2s ease;\n}\n\n.landing-link-arrow:hover {\n  color: var(--liberate-red-dark);\n  gap: 0.55rem;\n}\n\n/* ── EduGenie showcase ── */\n.landing-edugenie {\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(ellipse 70% 55% at 95% 20%, rgba(165, 29, 36, 0.16), transparent 55%),\n    radial-gradient(ellipse 50% 40% at 0% 80%, rgba(165, 29, 36, 0.1), transparent 50%),\n    linear-gradient(135deg, #1a1a1a 0%, #2a1214 48%, #1a1a1a 100%);\n  color: #f5f5f5;\n  border-top: 3px solid var(--liberate-red);\n  border-bottom: 3px solid var(--liberate-red);\n}\n\n.landing-edugenie .landing-section-eyebrow {\n  color: #fca5a5;\n  background: rgba(179, 32, 37, 0.25);\n  border-color: rgba(252, 165, 165, 0.35);\n}\n\n.landing-edugenie .landing-section-title {\n  color: #ffffff;\n}\n\n.landing-edugenie .landing-section-title::after {\n  background: var(--liberate-red);\n}\n\n.landing-edugenie .landing-section-desc {\n  color: rgba(245, 245, 245, 0.82);\n  max-width: 34rem;\n}\n\n.landing-edugenie-name {\n  font-style: normal;\n  color: #fca5a5;\n}\n\n.landing-edugenie-caps {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem 1rem;\n}\n\n@media (max-width: 575.98px) {\n  .landing-edugenie-caps {\n    grid-template-columns: 1fr;\n  }\n}\n\n.landing-edugenie-cap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  font-size: 0.9375rem;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.landing-edugenie-cap-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: rgba(179, 32, 37, 0.45);\n  color: #fecaca;\n  flex-shrink: 0;\n}\n\n.landing-edugenie-note {\n  font-size: 0.8125rem;\n  color: rgba(245, 245, 245, 0.55);\n}\n\n.landing-edugenie-panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.25rem;\n  padding: 1.5rem 1.25rem 1.75rem;\n}\n\n.landing-edugenie-panel-glow {\n  position: absolute;\n  inset: 10% 15%;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(179, 32, 37, 0.45) 0%, transparent 70%);\n  pointer-events: none;\n  filter: blur(8px);\n}\n\n.landing-edugenie-avatar-wrap {\n  position: relative;\n  z-index: 1;\n  width: min(240px, 55vw);\n  height: min(240px, 55vw);\n  border-radius: 50%;\n  padding: 6px;\n  background: linear-gradient(145deg, #B32025, #6b1218 55%, #fca5a5);\n  box-shadow: 0 20px 48px rgba(179, 32, 37, 0.35);\n  animation: landing-edugenie-float 5s ease-in-out infinite;\n}\n\n.landing-edugenie-avatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  background: #1a1a1a;\n  display: block;\n}\n\n.landing-edugenie-chat-preview {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 380px;\n  padding: 1.15rem 1.25rem;\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(252, 165, 165, 0.25);\n  backdrop-filter: blur(8px);\n}\n\n.landing-edugenie-chat-head {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.75rem;\n}\n\n.landing-edugenie-badge {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #fff;\n  background: var(--liberate-red);\n  padding: 0.2rem 0.55rem;\n  border-radius: 9999px;\n}\n\n.landing-edugenie-chat-title {\n  font-weight: 700;\n  color: #fff;\n  font-size: 0.95rem;\n}\n\n.landing-edugenie-chat-intro {\n  font-size: 0.8125rem;\n  color: rgba(245, 245, 245, 0.65);\n}\n\n.landing-edugenie-prompt {\n  font-size: 0.875rem;\n  color: #fecaca;\n  padding: 0.55rem 0.75rem;\n  margin-bottom: 0.45rem;\n  border-radius: 0.65rem;\n  background: rgba(179, 32, 37, 0.22);\n  border: 1px solid rgba(252, 165, 165, 0.18);\n}\n\n.landing-edugenie-prompt:last-child {\n  margin-bottom: 0;\n}\n\n@keyframes landing-edugenie-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .landing-edugenie-avatar-wrap {\n    animation: none;\n  }\n}\n\n/* ── Powerful marketing sections (KREDO / LearnWorlds-inspired) ── */\n.landing-hero-proof {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  align-items: center;\n  margin-top: 1.5rem;\n  font-size: 0.8125rem;\n  color: var(--liberate-gray-600);\n  font-weight: 500;\n}\n\n.landing-hero-proof-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--liberate-red);\n  display: inline-block;\n}\n\n.landing-hero-visual {\n  position: relative;\n}\n\n.landing-hero-float-chip {\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 0.85rem;\n  background: #fff;\n  border: 1px solid var(--liberate-border);\n  border-radius: 9999px;\n  box-shadow: 0 10px 28px rgba(165, 29, 36, 0.14);\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--liberate-charcoal);\n  animation: landing-edugenie-float 4.5s ease-in-out infinite;\n}\n\n.landing-hero-float-chip img {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.landing-hero-float-chip--top {\n  top: -8px;\n  right: 8px;\n}\n\n.landing-hero-float-chip--bottom {\n  bottom: 18px;\n  left: -6px;\n  animation-delay: 0.8s;\n}\n\n.landing-mock-progress {\n  height: 6px;\n  border-radius: 9999px;\n  background: #f0e4e4;\n  overflow: hidden;\n  margin-top: 0.35rem;\n}\n\n.landing-mock-progress > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, var(--liberate-red), #e05a5e);\n}\n\n.landing-mock-course-row {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.65rem 0;\n  border-bottom: 1px solid #f0e8e8;\n}\n\n.landing-mock-course-row:last-child {\n  border-bottom: none;\n}\n\n.landing-mock-course-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 0.55rem;\n  background: var(--liberate-red-bg-deep);\n  color: var(--liberate-red);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 0.9rem;\n}\n\n.landing-audience-card {\n  height: 100%;\n  padding: 1.75rem;\n  border-radius: 1.15rem;\n  background: #fff;\n  border: 1px solid var(--liberate-border);\n  border-top: 4px solid var(--liberate-red);\n  transition: transform 0.22s ease, box-shadow 0.22s ease;\n}\n\n.landing-audience-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 40px rgba(165, 29, 36, 0.12);\n}\n\n.landing-audience-card ul {\n  margin: 1rem 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.landing-audience-card li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--liberate-gray-700);\n  margin-bottom: 0.45rem;\n}\n\n.landing-pillar-card {\n  height: 100%;\n  padding: 1.65rem;\n  border-radius: 1.15rem;\n  background: #fff;\n  border: 1px solid var(--liberate-border);\n  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.landing-pillar-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--liberate-red), #e05a5e);\n  opacity: 0;\n  transition: opacity 0.22s ease;\n}\n\n.landing-pillar-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 36px rgba(165, 29, 36, 0.12);\n  border-color: rgba(165, 29, 36, 0.28);\n}\n\n.landing-pillar-card:hover::before {\n  opacity: 1;\n}\n\n.landing-pillar-num {\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  color: #fca5a5;\n  margin-bottom: 0.75rem;\n}\n\n.landing-solution-card {\n  height: 100%;\n  padding: 1.5rem;\n  border-radius: 1rem;\n  background: linear-gradient(180deg, #fff 0%, var(--liberate-red-bg) 100%);\n  border: 1px solid var(--liberate-border);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.landing-solution-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 32px rgba(165, 29, 36, 0.1);\n}\n\n.landing-solution-card .landing-link-arrow {\n  margin-top: 1rem;\n}\n\n.landing-steps {\n  display: grid;\n  gap: 1.25rem;\n}\n\n@media (min-width: 992px) {\n  .landing-steps {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1.5rem;\n  }\n}\n\n.landing-step {\n  position: relative;\n  padding: 1.5rem 1.25rem;\n  border-radius: 1rem;\n  background: #fff;\n  border: 1px solid var(--liberate-border);\n  height: 100%;\n}\n\n.landing-step-num {\n  font-size: 2rem;\n  font-weight: 800;\n  line-height: 1;\n  color: var(--liberate-red);\n  opacity: 0.35;\n  margin-bottom: 0.75rem;\n  letter-spacing: -0.04em;\n}\n\n.landing-enterprise-band {\n  background:\n    radial-gradient(ellipse 60% 50% at 0% 50%, rgba(165, 29, 36, 0.12), transparent 55%),\n    linear-gradient(135deg, #fff 0%, var(--liberate-red-bg) 100%);\n  border-top: 1px solid rgba(165, 29, 36, 0.12);\n  border-bottom: 1px solid rgba(165, 29, 36, 0.12);\n}\n\n.landing-enterprise-item {\n  display: flex;\n  gap: 1rem;\n  padding: 1.15rem 0;\n  border-bottom: 1px solid rgba(165, 29, 36, 0.12);\n}\n\n.landing-enterprise-item:last-child {\n  border-bottom: none;\n}\n\n.landing-enterprise-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 0.75rem;\n  background: var(--liberate-red);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 1.1rem;\n}\n\n.landing-nav-link-hash {\n  cursor: pointer;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n\n  .landing-hero-float-chip {\n    animation: none;\n  }\n}\n\n/* ── Compact enquiry contact panel ── */\n.landing-contact-panel {\n  border-radius: 1.15rem;\n  overflow: hidden;\n  border: 1px solid var(--liberate-border);\n  background: #fff;\n  box-shadow: 0 12px 32px rgba(165, 29, 36, 0.08);\n  position: sticky;\n  top: 96px;\n}\n\n.landing-contact-panel-head {\n  background: linear-gradient(135deg, var(--liberate-red-dark), var(--liberate-red));\n  color: #fff;\n  padding: 1.35rem 1.35rem 1.15rem;\n}\n\n.landing-contact-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n}\n\n@media (max-width: 575.98px) {\n  .landing-contact-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .landing-contact-panel {\n    position: static;\n  }\n}\n\n.landing-contact-item {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.15rem;\n  border-bottom: 1px solid var(--liberate-border);\n  border-right: 1px solid var(--liberate-border);\n  min-height: 0;\n}\n\n.landing-contact-item:nth-child(2n) {\n  border-right: none;\n}\n\n.landing-contact-item:nth-last-child(-n + 2) {\n  border-bottom: none;\n}\n\n@media (max-width: 575.98px) {\n  .landing-contact-item {\n    border-right: none;\n  }\n\n  .landing-contact-item:last-child {\n    border-bottom: none;\n  }\n\n  .landing-contact-item:nth-last-child(-n + 2) {\n    border-bottom: 1px solid var(--liberate-border);\n  }\n}\n\n.landing-contact-item-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--liberate-red-bg-deep);\n  color: var(--liberate-red);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.landing-contact-item-title {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  margin: 0 0 0.25rem;\n  color: var(--liberate-charcoal);\n}\n\n.landing-contact-item-line {\n  font-size: 0.8125rem;\n  color: var(--liberate-gray-700);\n  line-height: 1.45;\n}\n\n.landing-contact-item-link {\n  display: block;\n  color: var(--liberate-red);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.landing-contact-item-link:hover {\n  text-decoration: underline;\n  color: var(--liberate-red-dark);\n}\n\n.landing-contact-footnote {\n  padding: 0.85rem 1.15rem 1.15rem;\n  font-size: 0.75rem;\n  color: var(--liberate-gray-600);\n  border-top: 1px solid var(--liberate-border);\n  background: var(--liberate-red-bg);\n}\n\n.landing-contact-footnote a {\n  color: var(--liberate-red);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.landing-contact-footnote a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
